import { z } from 'zod';

const ArchivoCompraAgilSchema = z.object({
  nombre: z.string(),
  url_externa: z.string(),
  path_local: z.string()
});

const PreguntaRespuestaCompraAgilSchema = z.object({
  texto: z.string(),
  tipo: z.string(),
  orden: z.number()
});

const JsonMetadataCompraAgilSchema = z.any();

const CompraAgilDataSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  resumen: z.string().nullable(),
  codigo_externo: z.string(),
  codigo_estado: z.number(),
  estado_compra_agil: z.string(),
  estado_notificacion: z.string(),
  fecha_creacion: z.string().nullable(),
  fecha_cierre: z.string().nullable(),
  fecha_actualizacion: z.string().nullable(),
  fecha_resumen_procesado: z.string().nullable(),
  fecha_archivos_procesados: z.string().nullable(),
  filtro_resumen_aprobado: z.boolean().nullable(),
  filtro_archivos_aprobado: z.boolean().nullable(),
  archivos_descargados: z.boolean().nullable(),
  archivos_procesados: z.boolean().nullable(),
  resumen_procesado_filtro_palabras: z.boolean().nullable(),
  resumen_aprobado_filtro_palabras: z.boolean().nullable(),
  resumen_procesado_filtro_llm: z.boolean().nullable(),
  resumen_aprobado_filtro_llm: z.boolean().nullable(),
  resumen_llm: z.string().nullable(),
  puntaje: z.number().nullable(),
  usuario_ultima_actualizacion_id: z.number().nullable().optional(),
  json_metadata: JsonMetadataCompraAgilSchema.nullable(),
  visto: z.array(z.number()).nullable(),
  postulado: z.boolean().nullable(),
  fecha_postulacion: z.string().nullable(),
  adjudicado: z.boolean().nullable(),
  fecha_adjudicacion: z.string().nullable()
});

const CompraAgilSchema = z.object({
  data: CompraAgilDataSchema,
  archivos: z.array(ArchivoCompraAgilSchema),
  preguntas_y_respuestas_compra_agil: z.array(PreguntaRespuestaCompraAgilSchema)
});

export const PaginatedComprasAgilesResponseSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  data: z.array(CompraAgilSchema),
  extra: z.record(z.any()).nullable().optional()
});

export const ListarComprasAgilesResponseSchema = PaginatedComprasAgilesResponseSchema;

export type ListarComprasAgilesResponse = z.infer<typeof ListarComprasAgilesResponseSchema>;
export type CompraAgil = z.infer<typeof CompraAgilSchema>;
export type CompraAgilData = z.infer<typeof CompraAgilDataSchema>;
export type JsonMetadataCompraAgil = z.infer<typeof JsonMetadataCompraAgilSchema>;
export type ArchivoCompraAgil = z.infer<typeof ArchivoCompraAgilSchema>;
export type PreguntaRespuestaCompraAgil = z.infer<typeof PreguntaRespuestaCompraAgilSchema>; 